(function () {
  // ---- Cookie helpers ----
  function setCookie(name, value, days) {
    var expires = "";
    if (typeof days === "number") {
      var d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + d.toUTCString();
    }
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    var prefix = name + "=";
    var parts = document.cookie.split(";");
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i].trim();
      if (c.indexOf(prefix) === 0) return decodeURIComponent(c.substring(prefix.length));
    }
    return null;
  }

  // ---- Config ----
  var COOKIE_NAME = "pdp_selected_size";   // change if you want
  var COOKIE_DAYS = 30;

  // Horizon-style picker: <input type="radio" name="Size-..." value="7" data-option-available="true">
  function isSizeRadio(el) {
    return !!(el &&
      el.matches &&
      el.matches('input[type="radio"][name^="Size-"]')
    );
  }

  function isAvailableSizeRadio(el) {
    // Prefer data-option-available when present (your markup has it)
    // Fall back to not-disabled.
    var attr = el.getAttribute("data-option-available");
    if (attr != null) return attr === "true";
    return !el.disabled && el.getAttribute("aria-disabled") !== "true";
  }

  // ---- 1) Store cookie when a visitor selects a size ----
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!isSizeRadio(t)) return;
    if (!t.checked) return;
    // Store the raw value (e.g. "7")
    setCookie(COOKIE_NAME, t.value, COOKIE_DAYS);
    // Refresh badges immediately if collection cards are present on this page
    applyInSizeBadges();
  }, true);

  // ---- 2) On page load, apply size from cookie ----
  function applySavedSize() {
    var saved = getCookie(COOKIE_NAME);
    if (!saved) return;

    // Find a matching size option on THIS product
    var selector = 'input[type="radio"][name^="Size-"][value="' + CSS.escape(saved) + '"]';
    var candidate = document.querySelector(selector);
    if (!candidate) return;
    if (!isAvailableSizeRadio(candidate)) return;

    // If already selected, do nothing
    if (candidate.checked) return;

    // Prefer click() so the theme’s variant logic runs exactly as if user clicked
    candidate.click();

    // Safety: some themes rely on change/input; fire them too
    candidate.dispatchEvent(new Event("input", { bubbles: true }));
    candidate.dispatchEvent(new Event("change", { bubbles: true }));
  }
  window.applySavedSize = applySavedSize;

  // Run after DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applySavedSize);
  } else {
    applySavedSize();
  }

  // ---- 3) "In size X" badges on collection pages ----
  function injectSizeBadgeStyles() {
    if (document.getElementById("rr-size-badge-style")) return;
    var s = document.createElement("style");
    s.id = "rr-size-badge-style";
    s.textContent =
      "li[data-avail-sizes]{position:relative;}" +
      ".rr-size-badge{" +
      "position:absolute;top:8px;left:8px;" +
      "background:#1a1a1a;color:#fff;" +
      "font-size:0.65rem;letter-spacing:0.06em;text-transform:uppercase;" +
      "padding:3px 8px;border-radius:2px;" +
      "pointer-events:none;z-index:10;line-height:1.4;" +
      "}";
    document.head.appendChild(s);
  }

  function applyInSizeBadges() {
    var saved = getCookie(COOKIE_NAME);
    document.querySelectorAll(".rr-size-badge").forEach(function (el) { el.remove(); });
    if (!saved) return;
    document.querySelectorAll("li[data-avail-sizes]").forEach(function (li) {
      var attrVal = li.getAttribute("data-avail-sizes");
      if (!attrVal || !attrVal.includes("|" + saved + "|")) return;
      var badge = document.createElement("div");
      badge.className = "rr-size-badge";
      badge.textContent = "In your size";
      li.appendChild(badge);
    });
  }

  function initSizeBadges() {
    injectSizeBadgeStyles();
    applyInSizeBadges();
    var target = document.querySelector("results-list") || document.body;
    var debounceTimer;
    new MutationObserver(function (records) {
      var onlyBadges = records.every(function (r) {
        return Array.from(r.addedNodes).concat(Array.from(r.removedNodes)).every(function (n) {
          return !n.classList || n.classList.contains("rr-size-badge");
        });
      });
      if (onlyBadges) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(applyInSizeBadges, 60);
    }).observe(target, { childList: true, subtree: true });
  }

  window.addEventListener("load", initSizeBadges);
})();
